import React from "react";
import { Link } from "react-router-dom";

const SideBar = () => {
  return (
    <>
      {/* Sidebar */ }
      <ul
        className="navbar-nav bg-gradient-info sidebar sidebar-dark accordion"
        id="accordionSidebar"
      >
        {/* Sidebar - Brand */ }
        <a
          className="sidebar-brand d-flex align-items-center justify-content-center"
          href="/dashboard"
        >
          <div className="sidebar-brand-icon rotate-n-15">
            <i class="fab fa-pied-piper-hat"></i>
          </div>
          <div className="sidebar-brand-text mx-3">RPI</div>
        </a>
        {/* Divider */ }
        <hr className="sidebar-divider my-0" />
        {/* Nav Item - Dashboard */ }
        <li className="nav-item active">
          <a className="nav-link">
            <i className="fas fa-fw fa-tachometer-alt" />
            <span>Dashboard</span>
          </a>
        </li>
        {/* Divider */ }
        <hr className="sidebar-divider" />
        {/* Heading */ }
        <div className="sidebar-heading">Interface</div>
        {/* Nav Item - Pages Collapse Menu */ }
        {/*  <li className="nav-item">
          <a
            className="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="true"
            aria-controls="collapseTwo"
          >
            <i className="fas fa-fw fa-cog" />
            <span>Components</span>
          </a>
          <div
            id="collapseTwo"
            className="collapse"
            aria-labelledby="headingTwo"
            data-parent="#accordionSidebar"
          >
            <div className="bg-white py-2 collapse-inner rounded">
              <h6 className="collapse-header">Custom Components:</h6>
              <a className="collapse-item" href="buttons.html">
                Buttons
              </a>
              <a className="collapse-item" href="cards.html">
                Cards
              </a>
            </div>
          </div>
        </li> */}
        {/* Nav Item - Utilities Collapse Menu */ }
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapsePermisos"
            aria-expanded="true"
            aria-controls="collapsePermisos"
          >
            <i class="fas fa-paperclip"></i>
            <span>Certificados</span>
          </a>
          <div
            id="collapsePermisos"
            className="collapse"
            aria-labelledby="headingPermisos"
            data-parent="#accordionSidebar"
          >
            <div className="bg-white py-2 collapse-inner rounded">
              <h6 className="collapse-header">Opciones:</h6>
              <Link className="collapse-item" to="/gravamenes">
                Certificados
              </Link>
              {/* <Link className="collapse-item" to="/gravamenes">
                Búsqueda/Bienes
              </Link>
              <Link className="collapse-item" to="/gravamenes">
                Transferencia
              </Link> */}
            </div>
          </div>
        </li>
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapsePagos"
            aria-expanded="true"
            aria-controls="collapsePagos"
          >
            <i class="fas fa-credit-card"></i>
            <span>Pagar trámite</span>
          </a>
          <div
            id="collapsePagos"
            className="collapse"
            aria-labelledby="headingPagos"
            data-parent="#accordionSidebar"
          >
            <div className="bg-white py-2 collapse-inner rounded">
              <h6 className="collapse-header">Opciones:</h6>
              <a className="collapse-item" to="/gravamenes" href="http://servicioselectronicos.rpi.gob.ec:4005" target="_blank">
                Pagos con tarjeta
              </a>
              <a className="collapse-item" to="/gravamenes" href="https://www.intermatico.com/ebanking/seguridad/login.htm" target="_blank">
                Banca Virtual
              </a>
            </div>
          </div>
        </li>
        {/* <li className="nav-item">
          <a
            className="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapseEstado"
            aria-expanded="true"
            aria-controls="collapseEstado"
          >
            <i class="fas fa-search"></i>
            <span>Consultar estado trámite</span>
          </a>
          <div
            id="collapseEstado"
            className="collapse"
            aria-labelledby="headingEstado"
            data-parent="#accordionSidebar"
          >
            <div className="bg-white py-2 collapse-inner rounded">
              <h6 className="collapse-header">Opciones:</h6>
              <Link className="collapse-item" to="/consultar">
                Consultar
              </Link>
            </div>
          </div>
        </li> */}
        {/*  <li className="nav-item">
          <a
            className="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapseUtilities"
            aria-expanded="true"
            aria-controls="collapseUtilities"
          >
            <i className="fas fa-fw fa-wrench" />
            <span>Configuración</span>
          </a>
          <div
            id="collapseUtilities"
            className="collapse"
            aria-labelledby="headingUtilities"
            data-parent="#accordionSidebar"
          >
            <div className="bg-white py-2 collapse-inner rounded">
              <h6 className="collapse-header">Ajustes disponibles:</h6>
              <Link className="collapse-item" to="/funcionarios">
                Funcionarios
              </Link>
              <Link className="collapse-item" to="/tipopermisos">
                Tipos de permisos
              </Link>
            </div>
          </div>
        </li> */}
        {/* Divider */ }
        {/* <hr className="sidebar-divider" /> */ }
        {/* Heading */ }
        {/*   <div className="sidebar-heading">Addons</div> */ }
        {/* Nav Item - Pages Collapse Menu */ }
        {/* <li className="nav-item">
          <a
            className="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapsePages"
            aria-expanded="true"
            aria-controls="collapsePages"
          >
            <i className="fas fa-fw fa-folder" />
            <span>Pages</span>
          </a>
          <div
            id="collapsePages"
            className="collapse"
            aria-labelledby="headingPages"
            data-parent="#accordionSidebar"
          >
            <div className="bg-white py-2 collapse-inner rounded">
              <h6 className="collapse-header">Login Screens:</h6>
              <a className="collapse-item" href="login.html">
                Login
              </a>
              <a className="collapse-item" href="register.html">
                Register
              </a>
              <a className="collapse-item" href="forgot-password.html">
                Forgot Password
              </a>
              <div className="collapse-divider" />
              <h6 className="collapse-header">Other Pages:</h6>
              <a className="collapse-item" href="404.html">
                404 Page
              </a>
              <a className="collapse-item" href="blank.html">
                Blank Page
              </a>
            </div>
          </div>
        </li> */}
        {/* Nav Item - Charts */ }
        {/*     <li className="nav-item">
          <a className="nav-link" href="charts.html">
            <i className="fas fa-fw fa-chart-area" />
            <span>Charts</span>
          </a>
        </li> */}
        {/* Nav Item - Tables */ }
        {/*  <li className="nav-item">
          <a className="nav-link" href="tables.html">
            <i className="fas fa-fw fa-table" />
            <span>Tables</span>
          </a>
        </li> */}
        {/* Divider */ }
        <hr className="sidebar-divider d-none d-md-block" />
      </ul>
      {/* End of Sidebar */ }
    </>
  );
};

export default SideBar;
